import fpEntrance from "@/assets/floorplan-entrance.webp";
import fpMain from "@/assets/floorplan-main.webp";
import fpSecond from "@/assets/floorplan-second.webp";

export const PROPERTY = {
  brand: "461 BEECHWOOD",
  name: "461 Beechwood",
  tagline: "A two-bedroom condominium townhouse in Waterloo's Beechwood community",
  address: "52-461 Beechwood Place, Waterloo, ON N2T 1Y9",
  priceCad: 399900,
  specs: {
    bedrooms: 2,
    bathrooms: "1.5",
    type: "Condo Townhouse",
    taxes: "$2,606.72 (2026)",
    exteriorArea: "1,077 sq ft",
  },
  description:
    "52-461 Beechwood Place, Unit 52, is a two-bedroom, one-and-a-half-bathroom condominium townhouse in Waterloo, Ontario with 1,077 sq ft across three levels (iGuide exterior areas). 2026 property taxes are $2,606.72. Send an enquiry below for the full listing package.",
  contactEmail: "info@ramautor.com",
  heroImage:
    "https://images.unsplash.com/photo-1781231444047-3736480fa5f9?crop=entropy&cs=srgb&fm=jpg&q=85",
  heroSecondary:
    "https://images.unsplash.com/photo-1767352328589-61ff4922201d?crop=entropy&cs=srgb&fm=jpg&q=85",
  // Official iGuide walkthrough (owner-provided).
  tourEmbedUrl: "https://unbranded.youriguide.com/52_461_beechwood_pl_waterloo_on",
  tourNote: "Room previews use your listing photos — launch the official iGuide walkthrough for the full 3D tour.",
};

export const GALLERY = [
  {
    url: "https://images.unsplash.com/photo-1781231444047-3736480fa5f9?crop=entropy&cs=srgb&fm=jpg&q=85",
    category: "Exterior",
    title: "Beechwood Community",
    desc: "Sample photo — real listing photos will replace these.",
  },
  {
    url: "https://images.unsplash.com/photo-1603072845032-7b5bd641a82a?crop=entropy&cs=srgb&fm=jpg&q=85",
    category: "Interior",
    title: "Living Space",
    desc: "Sample photo — real listing photos will replace these.",
  },
  {
    url: "https://images.unsplash.com/photo-1638454795595-0a0abf68614d?crop=entropy&cs=srgb&fm=jpg&q=85",
    category: "Interior",
    title: "Bright Lounge",
    desc: "Sample photo — real listing photos will replace these.",
  },
  {
    url: "https://images.unsplash.com/photo-1600210491305-7396500b5b31?crop=entropy&cs=srgb&fm=jpg&q=85",
    category: "Bedrooms",
    title: "Primary Bedroom",
    desc: "Sample photo — real listing photos will replace these.",
  },
  {
    url: "https://images.unsplash.com/photo-1633948393301-d43e3ec0e5cd?crop=entropy&cs=srgb&fm=jpg&q=85",
    category: "Bedrooms",
    title: "Bedroom Two",
    desc: "Sample photo — real listing photos will replace these.",
  },
  {
    url: "https://images.unsplash.com/photo-1767352328589-61ff4922201d?crop=entropy&cs=srgb&fm=jpg&q=85",
    category: "Exterior",
    title: "Townhouse Streetscape",
    desc: "Sample photo — real listing photos will replace these.",
  },
];

export const TEASER_IMAGES = [
  PROPERTY.heroImage,
  PROPERTY.heroSecondary,
  ...GALLERY.map((g) => g.url).slice(0, 4),
];

export const TOUR_ROOMS = [
  {
    id: "living_room",
    name: "Living Room",
    image:
      "https://images.unsplash.com/photo-1638454795595-0a0abf68614d?crop=entropy&cs=srgb&fm=jpg&q=85",
    hotspots: [
      { x: 42, y: 55, label: "Open-Concept Layout", detail: "Living and dining areas flow together — sample photo shown." },
      { x: 74, y: 42, label: "Bright Windows", detail: "Ask about natural light and window orientation." },
    ],
  },
  {
    id: "primary_bedroom",
    name: "Primary Bedroom",
    image:
      "https://images.unsplash.com/photo-1600210491305-7396500b5b31?crop=entropy&cs=srgb&fm=jpg&q=85",
    hotspots: [
      { x: 50, y: 50, label: "Primary Bedroom", detail: "First of the two bedrooms — sample photo shown." },
    ],
  },
  {
    id: "bedroom_two",
    name: "Bedroom Two",
    image:
      "https://images.unsplash.com/photo-1633948393301-d43e3ec0e5cd?crop=entropy&cs=srgb&fm=jpg&q=85",
    hotspots: [
      { x: 55, y: 48, label: "Flexible Second Room", detail: "Guest room, home office — or both." },
    ],
  },
  {
    id: "grounds",
    name: "Community Grounds",
    image:
      "https://images.unsplash.com/photo-1781231444047-3736480fa5f9?crop=entropy&cs=srgb&fm=jpg&q=85",
    hotspots: [
      { x: 48, y: 60, label: "Condo Townhouse Community", detail: "Beechwood Place — sample photo shown." },
    ],
  },
];

export const FLOOR_PLANS = [
  {
    id: "entrance",
    label: "Entrance Level",
    image: fpEntrance,
    interior: "56.37 sq ft",
    exterior: "83.57 sq ft",
    rooms: [
      { name: "Foyer", dims: "Interior floor area — 56.37 sq ft" },
      { name: "Closet", dims: "Coat closet off the foyer" },
      { name: "Stairs", dims: "Up to the Main Floor" },
      { name: "Porch", dims: "Exterior area — 83.57 sq ft" },
    ],
  },
  {
    id: "main",
    label: "Main Floor",
    image: fpMain,
    interior: "506.97 sq ft",
    exterior: "571.25 sq ft",
    rooms: [
      { name: "Living", dims: "19'8\" x 19'", sqft: "281 sq ft" },
      { name: "Kitchen", dims: "9' x 8'2\"", sqft: "64 sq ft" },
      { name: "2PC Bath", dims: "7' x 3'", sqft: "20 sq ft" },
      { name: "Laundry", dims: "Off the kitchen" },
      { name: "Utility", dims: "Separate utility room" },
      { name: "Storage", dims: "Off the living area" },
      { name: "Hallway", dims: "Connects both halls" },
      { name: "Balcony", dims: "Walk-out — exterior area" },
    ],
  },
  {
    id: "second",
    label: "2nd Floor",
    image: fpSecond,
    interior: "369.92 sq ft",
    exterior: "422.25 sq ft",
    rooms: [
      { name: "Primary Bedroom", dims: "12'2\" x 11'2\"", sqft: "136 sq ft" },
      { name: "Bedroom", dims: "12'2\" x 8'", sqft: "87 sq ft" },
      { name: "4PC Bath", dims: "6'2\" x 7'8\"", sqft: "44 sq ft" },
      { name: "Closet", dims: "Off the bedroom hall" },
      { name: "Hallway", dims: "Stairs down to Main Floor" },
    ],
  },
];

export const POI_CATEGORIES = [
  { id: "schools", label: "Schools" },
  { id: "parks", label: "Parks & Recreation" },
  { id: "shopping", label: "Shopping" },
  { id: "transit", label: "Getting Around" },
];

export const POI_COLORS = {
  schools: "#5E7C8B",
  parks: "#7C8F6E",
  shopping: "#B88E62",
  transit: "#A2794F",
};

export const POIS = [
  { id: "poi-1", cat: "schools", name: "University of Waterloo", desc: "One of Canada's top engineering and innovation campuses.", dist: "Nearby", x: 30, y: 24 },
  { id: "poi-2", cat: "schools", name: "Wilfrid Laurier University", desc: "Bustling campus and Golden Hawks athletics.", dist: "Nearby", x: 58, y: 16 },
  { id: "poi-3", cat: "parks", name: "Waterloo Park", desc: "The jewel of the city — trails, zoo and picnic lawns.", dist: "Nearby", x: 40, y: 62 },
  { id: "poi-4", cat: "parks", name: "RIM Park", desc: "Sports complexes, concerts and conservation trails.", dist: "Nearby", x: 66, y: 70 },
  { id: "poi-5", cat: "parks", name: "Waterloo Recreation Complex", desc: "Pool, fitness and community programming.", dist: "Nearby", x: 18, y: 44 },
  { id: "poi-6", cat: "shopping", name: "Conestoga Mall", desc: "Major retail, dining and services under one roof.", dist: "Nearby", x: 62, y: 38 },
  { id: "poi-7", cat: "shopping", name: "Uptown Waterloo", desc: "Independent shops, cafes and the farmers' market.", dist: "Nearby", x: 46, y: 78 },
  { id: "poi-8", cat: "shopping", name: "St. Jacobs Farmers' Market", desc: "Canada's largest year-round farmers' market.", dist: "Nearby", x: 24, y: 70 },
  { id: "poi-9", cat: "transit", name: "Grand River Transit", desc: "Local bus routes connecting Beechwood to Uptown.", dist: "Nearby", x: 34, y: 36 },
  { id: "poi-10", cat: "transit", name: "ION Light Rail", desc: "Region-wide LRT with park-and-ride stations.", dist: "Nearby", x: 72, y: 26 },
  { id: "poi-11", cat: "transit", name: "Region of Waterloo Airport", desc: "Regional flights just outside the city.", dist: "Nearby", x: 84, y: 58 },
];

export const MARQUEE_ITEMS = [
  "Condo Townhouse",
  "Beechwood Place",
  "Two Bedrooms",
  "One & Half Bathrooms",
  "Waterloo · Ontario",
  "Welcome Home",
];

export const AGENT = {
  name: "Shawn Ramautor",
  title: "The Ramautor Team",
  brokerage: "Royal LePage Wolle Realty",
  phone: "519-741-4621",
  phoneHref: "tel:+15197414621",
  whatsapp: "https://wa.me/15197414621",
  email: "info@ramautor.com",
  replyEmail: "info@ramautor.com",
};
